import { IArticle, ICategory, ITemplate } from '@/types'
import { ArtistCardProps } from 'components/artists/ArtistCard'
import { ArtworkCardProps } from 'components/artwork/ArtworkCard'
import { ArticlesCarousel } from 'components/carousels/ArticlesCarousel'
import { MoreFromArtistCarousel } from 'components/carousels/MoreFromArtistCarousel'
import { ReleasesCarousel } from 'components/carousels/ReleasesCarousel'
import { SearchedArtworksCarousel } from 'components/carousels/SearchedArtworksCarousel'
import { TrendingArtistsCarousel } from 'components/carousels/TrendingArtistsCarousel'
import { TrendingArtworksCarousel } from 'components/carousels/TrendingArtworksCarousel'
import { getTemplateName } from 'utils/articles'

interface CarouselsMatrix {
  moreFromArtist?: boolean
  releases?: boolean
  articles?: boolean
  searchedArtworks?: boolean
  trendingArtworks?: boolean
  trendingArtists?: boolean
}

interface ArticleCarouselsProps {
  article: IArticle['attributes']
  has?: CarouselsMatrix
  trendingArtists?: ArtistCardProps[]
  trendingArtworks?: ArtworkCardProps[]
}

const defaultMatrix = {
  moreFromArtist: true,
  releases: true,
  articles: true,
  searchedArtworks: true,
  trendingArtworks: true,
  trendingArtists: true,
}

export const ArticleCarousels = ({
  article,
  has = defaultMatrix,
  trendingArtists,
  trendingArtworks,
}: ArticleCarouselsProps) => {
  if (
    !has.moreFromArtist &&
    !has.releases &&
    !has.articles &&
    !has.searchedArtworks &&
    !has.trendingArtworks &&
    !has.trendingArtists
  )
    return null

  return (
    <div className='w-full'>
      <div className='py-8 bg-cool-50'>
        {has.moreFromArtist && (
          <MoreFromArtistCarousel artist={article.artist.data} />
        )}
        {has.releases && <ReleasesCarousel />}
        {has.articles && article.category && article.template && (
          <ArticlesCarousel
            title={getArticlesCarouselTitle(article?.template?.[0])}
            filterKeywords={getArticlesCarouselFilterKeywords(
              article.category.data,
              article.template[0]
            )}
          />
        )}
      </div>

      <div className='pb-8 bg-cool-50'>
        {has.searchedArtworks && <SearchedArtworksCarousel />}
        {has.trendingArtists && (
          <TrendingArtistsCarousel trendingArtists={trendingArtists} />
        )}
        {has.trendingArtworks && (
          <TrendingArtworksCarousel trendingArtworks={trendingArtworks} />
        )}
      </div>
    </div>
  )
}

const getArticlesCarouselTitle = (template: ITemplate) => {
  switch (getTemplateName(template)) {
    case 'guide':
      return 'More guides'
    case 'artist-spotlight':
      return 'More artist spotlights'
    default:
      return 'More articles'
  }
}

const getArticlesCarouselFilterKeywords = (
  category: ICategory,
  template: ITemplate
) => {
  switch (getTemplateName(template)) {
    case 'guide':
    case 'artist-spotlight':
      return category?.attributes.name
    default:
      return
  }
}
